import React, { forwardRef, ForwardRefRenderFunction } from 'react';

interface VideoProps {
  classes?: string;
  src: string;
  autoplay?: boolean;
  loop?: boolean;
  muted?: boolean;
  playsinline?: boolean;
  controls?: boolean;
}

const Video: ForwardRefRenderFunction<HTMLVideoElement, VideoProps> = (
  {
    classes,
    autoplay = false,
    loop = true,
    muted = true,
    src,
    playsinline = true,
    controls = false,
  },
  ref,
) => {
  return (
    <video
      data-testid="video"
      className={classes}
      autoPlay={autoplay}
      loop={loop}
      muted={muted}
      playsInline={playsinline}
      controls={controls}
      controlsList="play timeline volume nofullscreen nodownload noremoteplayback noplaybackrate"
      ref={ref}
    >
      <source type="video/mp4" src={src} />
    </video>
  );
};

export default React.memo(forwardRef(Video));
